import React, { forwardRef } from "react";

import { RECIPIENTS } from "@stadium/ui/src/components/mail-to/constants";

const MailTo = forwardRef(({ recipient, content, subject, body, ...rest }, ref) => {
  const mailtoUrl = (() => {
    let url = `mailto:${recipient}`;
    const params = [];

    if (subject) {
      params.push(`subject=${encodeURIComponent(subject)}`);
    }

    if (body) {
      params.push(`body=${encodeURIComponent(body)}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return url;
  })();

  return (
    <a
      href={mailtoUrl}
      className="program-link text-decoration-none"
      target="_blank"
      data-skip-cross-domain-cookie-transfer="true"
      rel="noreferrer"
      ref={ref}
      {...rest}
    >
      {content || recipient}
    </a>
  );
});

export const MailToConcierge = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.concierge} {...props} />
);

export const MailToPurchasing = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.purchasing} {...props} />
);

export const MailToBrands = ({ ...props }) => <MailTo recipient={RECIPIENTS.brands} {...props} />;

export const MailToRestaurants = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.restaurants} {...props} />
);

export const MailToShop = ({ ...props }) => <MailTo recipient={RECIPIENTS.shops} {...props} />;

export const MailToTechSpecialist = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.specialist} {...props} />
);

export const MailToSuccess = ({ ...props }) => <MailTo recipient={RECIPIENTS.success} {...props} />;

export default MailTo;
